import { AppConfigService } from './app/core/app.config.service';
import { SESSIONS_PATHS } from './app/routes/sessions/sessions.paths';

(async (): Promise<void> => {
  try {
    const ready = await AppConfigService.initialize(
      SESSIONS_PATHS.serviceUnavailable,
    );
    if (!ready) {
      // Endpoint metadata is required for normal app startup; fall back to service unavailable page.
      globalThis.location.assign(SESSIONS_PATHS.serviceUnavailable);
      return;
    }

    const { bootstrapApp } = await import('./bootstrap');
    bootstrapApp();
  } catch (err) {
    console.error('Failed to load app config or bootstrap the app:', err);
  }
})();
